<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>El usuario con id: {{ $route.params.userId }} no se encuentra en la base de datos. </span>
      <span>
        <span>Ver la lista de </span><router-link :to="{name:'usuarios'}" class="text-inherit underline">Todos los usuarios</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="usuario">

      <vx-card card-border class="mb-4" title="Cuenta del usuario" title-color="dark" collapseAction>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Empresa</span>
            </div>
            <div>
              <vs-input class="w-full" disabled v-model="usuario.empresa.nombre" name="empresa" />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            &nbsp;
          </div>
        </div>
        <vs-divider color="dark">Login</vs-divider>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>Username</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="USERNAME" v-model="usuario.username" 
                v-validate="'required|alpha_num'" name="username" disabled />
              <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Contraseña</span>
            </div>
            <div>
              <vs-input type="password" class="w-full" data-vv-as="CONTRASEÑA" v-model="usuario.password" 
                v-validate="'required'" name="password" disabled />
              <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
            </div>
          </div>
        </div>
        <vs-divider color="dark">Datos del usuario</vs-divider>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>DNI</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="DNI" v-model="usuario.dni" v-validate="'required|alpha_num|checkDNI'" 
                name="dni" disabled />
              <span class="text-danger text-sm"  v-show="errors.has('dni')">{{ errors.first('dni') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            &nbsp;
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>Nombre</span>
            </div>
            <div>
              <vs-input disabled class="w-full" data-vv-as="NOMBRE" v-model="usuario.nombre" v-validate="'required'" name="nombre" />
              <span class="text-danger text-sm"  v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>Apellidos</span>
            </div>
            <div>
              <vs-input disabled class="w-full" data-vv-as="APELLIDOS" v-model="usuario.apellidos" v-validate="'required'" 
                name="apellidos" />
              <span class="text-danger text-sm"  v-show="errors.has('apellidos')">{{ errors.first('apellidos') }}</span>
            </div>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>E-mail</span>
            </div>
            <div>
              <vs-input disabled class="w-full" data-vv-as="EMAIL" v-model="usuario.email" type="email" 
                v-validate="'required|email'" name="email" />
              <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>Teléfono de contacto</span>
            </div>
            <div>
              <vs-input disabled class="w-full" data-vv-as="TELÉFONO DE CONTACTO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" 
                name="telefono" v-model="usuario.telefono"/>
              <span class="text-danger text-sm"  v-show="errors.has('telefono')">{{ errors.first('telefono') }}</span>
            </div>
          </div>
        </div>
        <vs-divider color="dark">Permisos</vs-divider>
        <div class="vx-row mb-8">
          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-col w-full mb-3">
              <span>Usuario inactivo/activo</span>
            </div>
            <div class="vx-col w-full mb-6">
              <vs-switch disabled vs-type="success" v-model="usuario.activo"/>
            </div>
            <div v-if="usuario.roles.includes('ROLE_COMERCIAL')" class="vx-col w-full mb-3">
              <span>Supervisor</span>
            </div>
            <div v-if="usuario.roles.includes('ROLE_COMERCIAL')" class="vx-col w-full">
              <v-select disabled class="w-full" 
                v-model="usuario.supervisor" 
                :options="supervisores" 
                :selectable="option => option.activo === true"
                label="nombre"
                :reduce="id => id.id" 
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vx-card no-shadow card-border>
              <div>
                <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                <span class="leading-none">Permisos especiales</span>
                </div>
                <vs-divider />
              </div>
              <div>
                <table class="w-full">
                  <tr>
                    <td><vs-switch disabled vs-type="success" v-model="usuario.roles" vs-value="ROLE_ADMIN">ROLE_ADMIN</vs-switch></td>
                    <td class="text-base text-left px-3 py-2">ADMINISTRADOR</td>
                  </tr>
                  <tr>
                    <td><vs-switch disabled vs-type="success" v-model="usuario.roles" vs-value="ROLE_SUPERVISOR">ROLE_SUPERVISOR</vs-switch></td>
                    <td class="text-base text-left px-3 py-2">SUPERVISOR</td>
                  </tr>
                  <tr>
                    <td><vs-switch disabled vs-type="success" v-model="usuario.roles" vs-value="ROLE_COMERCIAL">ROLE_COMERCIAL</vs-switch></td>
                    <td class="text-base text-left px-3 py-2">COMERCIAL</td>
                  </tr>
                </table>
              </div>
            </vx-card>
          </div>
        </div>
        
        <!-- Botóns -->
        <div class="vx-row" id="account-manage-buttons">
          <div class="vx-col sm:w-1/2 flex w-full">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{ name: 'usuariosEditar', params: { userId: $route.params.userId }}">Editar</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Borrar</vs-button>
          </div>
          <div class="vx-col sm:w-1/2 flex w-full justify-end">
            <vs-button color="warning" type="border" :to="{ name: 'usuarios' }">Cancelar</vs-button>
          </div>
        </div>
      </vx-card>

    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      usuario: null,
      supervisores: [],
      user_not_found: false
    }
  },
  computed: {
    supervisoresOptions () {
      // Combo de supervisores
      const supervisoresOptions =  this.supervisores.map(x => ({['id']: x.id, ['label']: `${x.nombre} ${x.apellidos}`}))
      return supervisoresOptions
    }
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación de borrado',
        text: `¿Seguro que quiere eliminar al usuario "${this.usuario.username}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar'
      })
    },
    deleteRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('userManagement/removeUser', this.usuario.id)
        .then(()   => { this.$router.push({name:'usuarios'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Usuario eliminado',
        text: 'El usuario ha sido eliminado'
      })
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    await this.$store.dispatch('userManagement/getSupervisores')
      .then(() => {
        // Recorremos as empresas e se están activas ou se teñen o mesmo id que o que ten asociado o usuario engadímolas ao combo
        this.$store.state.userManagement.supervisores.forEach(element => {
          if (element.activo) this.supervisores.push(element)
        })
      })
      .catch((error) => {
        console.log(error)
      })

    const userId = this.$route.params.userId
    await this.$store.dispatch('userManagement/fetchUser', userId)
      .then(res => { 
        this.usuario = res.data
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          this.user_not_found = true
          return
        }
        console.error(err) 
      })
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
